import AssignmentMappingsEditModal from './AssignmentMappingsEditModal';

export default AssignmentMappingsEditModal;
